import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
import store from '../store/index'
import { getAccountInfo } from '@r/api'
import { EventBus } from '@/assets/js/event-bus'

Vue.use(Router)

function loadView(view) {
    return () => import(`@/views/${view}.vue`)
}

function loadComponent(view) {
    return () => import(`@/components/${view}.vue`)
}

// 解决重复点击导航路由报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export const routes = [
    {
        path: '/login',
        name: 'login',
        component: loadView('login')
    },
    {
        path: '/',
        name: 'index',
        meta: { name: '首页', requireAuth: true, index: 'index' },
        component: loadView('index'),
        redirect: '/dashboard',
        children: [
            {
                path: 'password/change',
                name: 'passwordChange',
                component: loadView('password_change'),
                meta: { name: '修改密码', requireAuth: true, index: 'passwordChange' }
            },
            {
                path: 'dashboard',
                name: 'dashboard',
                component: loadView('dashboard'),
                meta: { name: '数据概览', requireAuth: true, index: 'dashboard' }
            },
            //
            // {
            //     path: 'login/statistics',
            //     name: 'loginStatistics',
            //     component: loadView('statistics/login_statistics'),
            //     meta: { name: '登录统计', requireAuth: true, index: 'loginStatistics' }
            // },

            {
                path: 'admin/log',
                name: 'adminLog',
                component: loadView('admin/log'),
                meta: { name: '日志统计', requireAuth: true, index: 'adminLog' }
            },

            {
                path: 'admin/role/list',
                name: 'adminRoleList',
                component: loadView('admin/role_list'),
                meta: { name: '角色权限维护', requireAuth: true, index: 'adminRoleList' }
            },
            {
                path: 'admin/privilege/list',
                name: 'adminPrivilegeList',
                component: loadView('admin/privilege_list'),
                meta: { name: '后台权限管理', requireAuth: true, index: 'adminPrivilegeList' }
            },
            {
                path: 'admin/menu/list',
                name: 'adminMenuList',
                component: loadView('admin/menu_list'),
                meta: { name: '后台菜单管理', requireAuth: true, index: 'adminMenuList' }
            },
            {
                path: 'admin/user/list',
                name: 'adminUserList',
                component: loadView('admin/user_list'),
                meta: { name: '后台账号管理', requireAuth: true, index: 'adminUserList' }
            },
            {
                path: 'admin/role/privilege',
                name: 'adminRoleRevise',
                component: loadView('admin/role_revise'),
                meta: { name: '权限列表', requireAuth: true, index: 'adminRoleList' }
            },
            {
                path: 'report/detail',
                name: 'reportDetail',
                component: loadView('report/detail'),
                meta: { name: '工作台', requireAuth: false, index: 'reportDetail' }
            },
            {
                path: 'report/list',
                name: 'reportList',
                component: loadView('report/list'),
                meta: { name: '我的报告', requireAuth: false, index: 'reportList' }
            },
            {
                path: 'all/report/list',
                name: 'allReportList',
                component: loadView('report/list_all'),
                meta: { name: '全部报告', requireAuth: false, index: 'allReportList' }
            },
            {
                path: 'auto-report/list',
                name: 'autoReportList',
                component: loadView('auto-report/autoList'),
                meta: { name: '我的报告任务', requireAuth: false, index: 'autoReportList' }
            },
            {
                path: 'all/auto-report/list',
                name: 'allAutoReportList',
                component: loadView('auto-report/autoListAll'),
                meta: { name: '全部报告任务', requireAuth: false, index: 'allAutoReportList' }
            },
            {
                path: 'customer/list',
                name: 'customerList',
                component: loadView('customer/list'),
                meta: { name: '客户列表', requireAuth: false, index: 'customerList' }
            },
            {
                path: 'report/template/list',
                name: 'reportTemplateList',
                component: loadView('report/template_list'),
                meta: { name: '报告模板', requireAuth: false, index: 'reportTemplateList' }
            },
            {
                path: 'report/word-template/list',
                name: 'wordTemplateList',
                component: loadView('report/word_template_list'),
                meta: { name: 'word模板', requireAuth: false, index: 'wordTemplateList' }
            },
            {
                path: 'tool/file/converter',
                name: 'fileConverter',
                component: loadView('tool/file_converter'),
                meta: { name: '文件转换', requireAuth: false, index: 'fileConverter' }
            },
            {
                path: 'tool/url/checklist',
                name: 'urlCheckList',
                component: loadView('tool/url_check_list'),
                meta: { name: '失效链接/互动数', requireAuth: false, index: 'urlCheckList' }
            },
            {
                path: 'tool/call/list',
                name: 'toolCallList',
                component: loadView('tool/call_list'),
                meta: { name: '操作记录', requireAuth: false, index: 'toolCallList' }
            },
            {
                path: 'report/workbench',
                name: 'workbench',
                component: loadView('report/workbench'),
                meta: { name: '政务预警', requireAuth: false, index: 'workbench' }
            },
            {
                path: '/tools/source/list',
                name: 'sourceList',
                component: loadView('source/source_list'),
                meta: { name: '媒体信源', requireAuth: false, index: 'sourceList' }
            },
            {
                path: '/tools/media/list',
                name: 'mediaList',
                component: loadView('source/media_list'),
                meta: { name: '媒体库', requireAuth: false, index: 'mediaList' }
            },
        ]
    },
    // 404page
    {
        path: '/error/info',
        name: 'errorInfo',
        component: loadView('error404'),
        meta: { name: '404页面', requireAuth: true, index: 'errorInfo' }
    }
]

//存储本地 routes name 数组
function getNames(menuList = []) {
    let names = []
    for (let index = 0; index < menuList.length; index++) {
        const element = menuList[index]
        if (element.children && element.children.length > 0) {
            names = names.concat(getNames(element.children))
        }
        if (element.name && !element.redirect) {
            names.push(element.name)
        }
    }
    return names
}
let names = getNames(routes)
sessionStorage.setItem('routes_names', JSON.stringify(names))

const router = new Router({
    routes
})
// 路由拦截
router.beforeEach((to, from, next) => {
    // 已登录状态下访问登录页，自动跳转到 dashboard
    if (to.name === 'login') {
        let token = VueCookies.get('4b25a36bac7956242a5c170c78339461')
        let userInfoCookie = Vue.$cookies.get('user_info')
        if (token || userInfoCookie) {
            next({ name: 'reportDetail' })
            return
        }
    }

    let userInfo = Vue.$cookies.get('user_info')
    if (!userInfo && to.name !== 'login') {
        getAccountInfo({}).then(data => {
            if (data && data.info) {
                Vue.$cookies.set('user_info', JSON.stringify(data.info))
                EventBus.$emit('updateUserInfo', data.info)
            } else {
                throw new Error()
            }
        }).catch(() => {
            console.error('获取用户信息接口异常')
        })
    }

    var jurisdiction = 0 //判断有没有权限，0无权限，1有权限
    if (sessionStorage.getItem('menuList')) {
        JSON.parse(sessionStorage.getItem('menuList')).forEach((v, i) => {
            if (v.submenuList) {
                v.submenuList.forEach((a, b) => {
                    if (a.url == to.name) {
                        jurisdiction++
                    }
                })
            }
        })
        setTimeout(function() {
            if (jurisdiction == 1) {
                // 如果路由存在
                if (to.name) {
                    if (to.meta.requireAuth) {
                        // 判断该路由是否需要登录权限
                        //判断登录是否过期
                        let token = VueCookies.get('4b25a36bac7956242a5c170c78339461')
                        if (!token && process.env.NODE_ENV != 'development') {
                            if (to.name != 'login') {
                                next({ name: 'login' })
                            } else {
                                next()
                            }
                        } else {

                            next()
                        }
                    } else {
                        next()
                    }
                }
                if (to.matched.length === 0) {
                    to.name
                        ? next({
                              name: to.name
                          })
                        : next('/error/info')
                } else {
                    next()
                }
            } else {
                if (
                    to.name == 'login' ||
                    to.name == 'passwordChange' ||
                    to.name == 'dashboard' ||
                    to.name == 'adminRoleRevise' ||
                    // to.name == 'cwooCustomerList' ||
                    (to.meta && !to.meta.requireAuth)
                ) {
                    next()
                } else {
                    //FIXME: 无页面调整面包屑显示优化
                    store.commit('menuIndex', sessionStorage.getItem('index'))
                    alert('您还没有该页面的查看权限！')
                }
            }
        }, 0)
    } else {
        next()
    }
})
//FIXME: 无页面调整面包屑显示优化
// router.afterEach((to, from) => {
//     store.commit('menuIndex', to.name)
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js